// ABOUTME: The v28 phase line, "{glyph} {PHASE} · {STEP}": the server's phase eyebrow plus a step word kept here per screen.
// ABOUTME: The only source of that text; screens never add their own.

import { TRUST_PHASES } from '../crossing/crossingTrustRail';

const STEP_BY_SCREEN: Record<string, string> = {
  '2A': 'FEELING',
  '2B': 'STORM',
  '2C': 'STORM',
  '2D': 'WEATHER RESPONSE',
  '3A': 'WHO FELT IT',
  '4A': 'MAKE IT RIGHT',
  '4B': 'FORGIVE',
  '5B': 'GUIDING TRUTH',
  '5C': 'LET GO',
  '5D': 'COMPASS',
};

const BREATHING_ROUND_STEP = 'BREATHE';

export interface PhaseLine {
  glyph: string;
  text: string;
}

// phaseNumber is 1-based, as the progress record carries it.
export function phaseLine(screenId: string, eyebrow: string, phaseNumber: number, variant?: 'breathing_round'): PhaseLine {
  const glyph = TRUST_PHASES[phaseNumber - 1]?.glyph ?? '';
  const step = variant === 'breathing_round' ? BREATHING_ROUND_STEP : STEP_BY_SCREEN[screenId];
  return { glyph, text: step ? `${eyebrow} · ${step}` : eyebrow };
}
